module.exports = [{"name":"30-Year Fixed Rate","description":"One loan with predictable payments","term":30,"baseRate":0.03625},{"name":"20-Year Fixed Rate","description":"One loan with predictable payments and shorter loan term","term":20,"baseRate":0.03625},{"name":"7/1 ARM","description":"One loan with fixed payments for first 7 years, then adjusts annually","term":30,"baseRate":0.03125},{"name":"30-Year Fixed-Rate FHA","description":"One loan with predictable payments. Mortgage Insurance is required.","term":30,"baseRate":0.04625}]


//////////////////
// WEBPACK FOOTER
// ./components/mortgage_calculator/loans.json
// module id = 412
// module chunks = 5